<div class="edit-component">
  <small class="debug">{{me}}</small>

  <!-- Modern Toolbar Container -->
  <div class="modern-toolbar-container">

    <!-- Design <-> Playlists toggle (miniView only, 2+ playlists): mirrors the top "Design | Playlists"
         switcher. The icon shows the mode you'll switch TO - Playlists (view_agenda) while in Design,
         Design (crop_original) while in the color-coded Playlists overview. -->
    @if (canShowAllPlaylists) {
      <div class="toolbar-section">
        <button mat-button class="toolbar-btn playlists-btn" [class.active]="showAllPlaylists"
                (click)="toggleShowAllPlaylists.emit()"
                matTooltip="{{ (showAllPlaylists ? 'scenes.viewDesignTip' : 'scenes.viewPlaylistsTip') | transloco }}"
                [matTooltipPosition]="'above'">
          <mat-icon>{{ showAllPlaylists ? 'crop_original' : 'view_agenda' }}</mat-icon>
        </button>
      </div>
    }

    <!-- Navigation Section (only the extended view has a back button; hidden in miniView so no empty box) -->
    @if (!miniView) {
      <div class="toolbar-section">
        <button mat-button class="toolbar-btn" (click)="onBackScene()" matTooltip="{{'general.backToScene' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
    }

    <!-- Content Actions Section -->
    <div class="toolbar-section">
      @if (!miniView) {
        <button mat-button class="toolbar-btn" (click)="addNewPlaylist()" matTooltip="{{'general.addPlaylist' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>playlist_add</mat-icon>
        </button>
      }
      <button mat-button class="toolbar-btn" (click)="addContent()" matTooltip="{{'general.addContent' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>add_photo_alternate</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="toggleScenePreview()"  matTooltip="{{'general.toggleScenePreview' | transloco}}"  [matTooltipPosition]="'above'">
        @if (scenePreviewEnabled) {
          <mat-icon>layers</mat-icon>
        }
        @if (!scenePreviewEnabled) {
          <mat-icon>layers_clear</mat-icon>
        }
      </button>
    </div>

    <!-- Edit Actions Section -->
    <div class="toolbar-section">
      <button mat-button class="toolbar-btn" (click)="onCopyPlayers();" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.copy' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="onPastePlayers($event);" [disabled]="copiedPlayers.length == 0" matTooltip="{{'general.paste' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>content_paste</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="onCutPlayers();" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.cut' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>content_cut</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="onRemovePlayers();" [disabled]="selectedIndexes.length==0" matTooltip="{{'general.removeItem' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>

    <!-- Item Actions Dropdown + open pages table dialog -->
    <div class="toolbar-section">
      <button mat-button class="toolbar-btn" [matMenuTriggerFor]="itemActionsMenu" matTooltip="{{'general.itemActions' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>playlist_add_check</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="openPagesDialog()" matTooltip="{{'general.openInDialog' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>grid_on</mat-icon>
      </button>
    </div>

    <!-- Alignment Section -->
    <div class="toolbar-section">
      <button mat-button class="toolbar-btn" (click)="onClickAlign('left');" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.alignLeft' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>first_page</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="onClickAlign('right');" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.alignRight' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>last_page</mat-icon>
      </button>
      <button mat-button class="toolbar-btn drill-btn" (click)="jumpToPlayer(selectedPlayers[0]);" [disabled]="selectedPlayers.length != 1" matTooltip="{{'general.drillIntoItem' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>login</mat-icon>
      </button>
    </div>

    <!-- History Section -->
    @if (!miniView && enableUndoRedo) {
      <div class="toolbar-section">
        <button mat-button class="toolbar-btn" (click)="onClickUndo();" [disabled]="disableUndo" matTooltip="{{'general.undo' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>undo</mat-icon>
        </button>
        <button mat-button class="toolbar-btn" (click)="onClickRedo();" [disabled]="disableRedo" matTooltip="{{'general.redo' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>redo</mat-icon>
        </button>
      </div>
    }

    <!-- Playlist Selection and Controls -->
    <div class="toolbar-section right-section">
      @if (propsMinimized) {
        <button mat-icon-button class="toolbar-btn" (click)="toggleMinimize.emit();">
          <mat-icon style="transform: rotate(180deg)">double_arrow</mat-icon>
        </button>
      }
    </div>

    <!-- Zoom Section (moved to the far right) -->
    <div class="toolbar-section">
      <button mat-button class="toolbar-btn" (click)="onClickZoomIn();" [disabled]="zoomIndex === 0" matTooltip="{{'general.zoomIn' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button mat-button class="toolbar-btn" (click)="onClickZoomOut();" [disabled]="zoomIndex === zoomLength - 1" matTooltip="{{'general.zoomOut' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <span class="zoom-label">{{1 / zoom * 100 | number: '1.0-0'}}%</span>
    </div>

  </div>

  <div @fadeIn class="timelineWrap playlistTimeline"
    (mouseout)="onMouseOut()"
    (mouseover)="onMouseOver()">
    @if (playlistSelection.length > 0 && state) {
      <app-playlist-timeline style="overflow: hidden"
        [setTimeLineState]="state"
        [zoom]="zoom"
        [scenePreviewEnabled]="scenePreviewEnabled"
        (clickChannel)="onClickChannel($event)"
        (resizeItems)="onResizeItems($event)"
        (moveItems)="onMoveItems($event)"
        (pastePages)="onPastePlayers($event)"
        (jumpToPlayer)="jumpToPlayer($event)">
      </app-playlist-timeline>
    } @else {
      <div class="empty">Please select playlists what you want to edit...</div>
    }
    <div class="drag-preview-item"></div>
  </div>

  <!-- Actions dropdown: selection + per-property setters (applied only to items that support each one) -->
  <mat-menu #itemActionsMenu="matMenu">
    <button mat-menu-item (click)="selectAllItems()">
      <mat-icon>select_all</mat-icon><span>{{'general.selectAll' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="selectNoneItems()">
      <mat-icon>deselect</mat-icon><span>{{'general.selectNone' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="reverseSelection()">
      <mat-icon>flip</mat-icon><span>{{'general.reverseSelection' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="setSelectedMaintainRatio(true)">
      <mat-icon>aspect_ratio</mat-icon><span>{{'general.maintainRatioOn' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="setSelectedMaintainRatio(false)">
      <mat-icon>crop_free</mat-icon><span>{{'general.maintainRatioOff' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="setSelectedVideoVolume(true)">
      <mat-icon>volume_off</mat-icon><span>{{'general.videoAudioMute' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="setSelectedVideoVolume(false)">
      <mat-icon>volume_up</mat-icon><span>{{'general.videoAudioFull' | transloco}}</span>
    </button>
  </mat-menu>
</div>
